import { trackCustomEvent } from "../Config/DataDog";

const analyzeUrlCallbackAuth0 = (url) => {
    const pathMobile = getMobilePath(url);
    if (isMobileCallback(pathMobile)) {
        window.location.href = pathMobile;
    } else {
        return;
    }
}

const getMobilePath = (url) => {
    let location = new URL(url);
    let pathMobile = location.pathname.replace('/auth0-callback/', '');
    return pathMobile;
}

const isMobileCallback = (pathMobile) => {
    return MOBILE_PATH_CALLBACK.includes(pathMobile) && userAgentIsMobile();
}

const userAgentIsMobile = () => {
    return navigator.userAgent.match(/Android|Mobile|webOS|iPhone|iPad|iPod|Windows Phone/i);
}

const MOBILE_PATH_CALLBACK = [
    process.env.REACT_APP_INITIATE_LOGIN_URI_IOS,
    process.env.REACT_APP_INITIATE_LOGIN_URI_ANDROID,
    process.env.REACT_APP_INITIATE_LOGIN_URI_IOS_CLUB,
    process.env.REACT_APP_INITIATE_LOGIN_URI_ANDROID_CLUB];

const isInAppBrowser = (userAgent) => {
    return /FBAN|FBAV|Instagram/.test(userAgent);
}

const redirectInAppToExternalBrowser = () => {
    try {
        const currentUrl = window.location.href;
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isInApp = isInAppBrowser(userAgent);
        const isMobile = /android/i.test(userAgent);

        if (isInApp && isMobile) {
            const urlToExternalBrowser = `intent://${currentUrl.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end;`;
            trackCustomEvent("Auth0MobileUtils - redirectInnAppToExternalBrowser", false, { urlToExternalBrowser, currentUrl })
            window.location = urlToExternalBrowser;
        }else{
            trackCustomEvent("Auth0MobileUtils - redirectInnAppToExternalBrowser", false, { isInAppBrowser: isInApp, isMobile, userAgent, currentUrl })
        }
    } catch (error) {
        trackCustomEvent("Auth0MobileUtils - redirectInnAppToExternalBrowser", true, { error })
    }
}

export { analyzeUrlCallbackAuth0, redirectInAppToExternalBrowser }